var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 6.54708C13.6984 6.54708 13.4559 6.78957 13.4559 7.09168V14.0005C13.4559 14.5014 13.0465 14.9108 12.5456 14.9108H1.9995C1.49863 14.9108 1.08919 14.5014 1.08919 14.0005V3.45441C1.08919 2.95354 1.49863 2.5441 1.9995 2.5441H8.90832C9.21043 2.5441 9.45292 2.30162 9.45292 1.99951C9.45292 1.69739 9.21043 1.45491 8.90832 1.45491H1.9995C0.898385 1.45491 0 2.3533 0 3.45441V14.0005C0 15.1056 0.898385 16 1.9995 16H12.5456C13.6507 16 14.5451 15.1016 14.5451 14.0005V7.09168C14.5451 6.78957 14.3026 6.54708 14.0005 6.54708Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4554 0H10.7289C10.5103 0 10.3076 0.13118 10.2241 0.337888C10.1406 0.544596 10.1883 0.775155 10.3434 0.930186L12.323 2.90981L6.71007 8.52273C6.49541 8.73739 6.49541 9.08323 6.71007 9.29391C6.8174 9.40124 6.95653 9.45292 7.09566 9.45292C7.23479 9.45292 7.37392 9.40124 7.48125 9.29391L13.0942 3.68099L15.0738 5.66062C15.1771 5.76398 15.3163 5.81963 15.4594 5.81963C15.5309 5.81963 15.5985 5.8077 15.6701 5.77988C15.8728 5.6964 16.008 5.49764 16.008 5.27503V0.544596C16.008 0.242484 15.7655 0 15.4634 0H15.4554ZM14.9108 3.95528L13.4837 2.5282C13.4837 2.5282 13.4798 2.52422 13.4758 2.52025C13.4718 2.51627 13.4718 2.51627 13.4678 2.5123L12.0407 1.08522H14.9068V3.9513L14.9108 3.95528Z",
    fill: "#1C1C1C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.ad1b6753398bc3f1b59f6b4eed2e794e.svg";
export { ForwardRef as ReactComponent };